// extracted by mini-css-extract-plugin
export var $animation_name = "EuroHeader-module--$animation_name--3fe56";
export var btn = "EuroHeader-module--btn--9b52d";
export var btnWrapper = "EuroHeader-module--btnWrapper--60050";
export var confetti = "EuroHeader-module--confetti--83ecd";
export var fans = "EuroHeader-module--fans--dbcf3";
export var float = "EuroHeader-module--float--40053";
export var intro = "EuroHeader-module--intro--ee3ef";
export var logos = "EuroHeader-module--logos--9d346";
export var overflowHidden = "EuroHeader-module--overflowHidden--6bb88";
export var pint = "EuroHeader-module--pint--7e15a";
export var splash = "EuroHeader-module--splash--4c4db";
export var text = "EuroHeader-module--text--d0ea5";
export var wrapper = "EuroHeader-module--wrapper--ee5c9";